<template lang="pug">
v-app
  v-container(fluid pa-0 fill-height)
    v-layout(justify-center align-center)
      router-view
  v-snackbar( v-model="Helpers.snackbarShow" :bottom='true' :right='true' :timeout='6000' ) {{Helpers.snackbarMessage }}
    v-btn( color="primary" @click="Helpers.snackbarShow = false") Cerrar
  v-snackbar( v-model="Helpers.estado_de_mensaje_de_base_de_datos" :bottom='true' :left='true' :timeout='6000' ) 
    small 
      strong Base de datos: 
      span {{ Helpers.mensaje_de_base_de_datos }}
    v-btn( color="primary" @click="Helpers.estado_de_mensaje_de_base_de_datos = false") Cerrar

</template>
<script>
import {mapActions, mapState, mapGetters} from 'vuex'
export default {
  created(){
    this.getAll() 
  },
  methods: {
    ...mapActions({
      getAll : 'Customers/getAll'
    })
  },

  computed: {
    ...mapState({
      Helpers: state => state.Helpers
    }),
  }
}
</script>
